import styled from 'styled-components';
import { StyledDiv } from '../../Theme/CommonStyled';

export const StyledBirthdayTitle = styled.div`
  text-align: right;
  font-size: ${({ theme }): string => theme.fontSizes[2]};
  color: ${({ theme }): string => theme.colors.minorText};
  margin-bottom: 8px;
  margin-right: 12px;
`;
export const StyledBirthday = styled(StyledDiv)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background-color: ${({ theme }): string => theme.colors.mainBackground};
  border-radius: ${({ theme }): string => theme.radii.xl};
  font-size: ${({ theme }): string => theme.fontSizes[6]};
  color: ${({ theme }): string => theme.colors.normalText};
`;

export const StyledEmailContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  direction: rtl;
  padding: 14px;
  background-color: ${({ theme }): string => theme.colors.mainBackground};
  border-radius: ${({ theme }): string => theme.radii.xl};
`;
